import type { RefObject, TouchEvent } from "react";
import { useCallback } from "react";

const MIN_SWIPE_DISTANCE = 50;

export type SwipeGestureCallbacks = { onSwipeLeft?: () => void; onSwipeRight?: () => void };

export function useSwipeGesture(touchStartX: RefObject<number>, touchEndX: RefObject<number>, callbacks: SwipeGestureCallbacks) {
	const handleTouchStart = useCallback(
		(e: TouchEvent<HTMLElement>): void => {
			touchStartX.current = e.touches[0].clientX;
			touchEndX.current = e.touches[0].clientX;
		},
		[touchStartX, touchEndX],
	);

	const handleTouchMove = useCallback(
		(e: TouchEvent<HTMLElement>): void => {
			touchEndX.current = e.touches[0].clientX;
		},
		[touchEndX],
	);

	const handleTouchEnd = useCallback((): void => {
		const swipeDistance = touchStartX.current - touchEndX.current;

		if (Math.abs(swipeDistance) > MIN_SWIPE_DISTANCE) {
			if (swipeDistance > 0) callbacks.onSwipeLeft?.();
			else if (swipeDistance < 0) callbacks.onSwipeRight?.();
		}

		// Reset touch positions after handling
		touchStartX.current = 0;
		touchEndX.current = 0;
	}, [touchStartX, touchEndX, callbacks]);

	return { handleTouchStart, handleTouchMove, handleTouchEnd };
}
